
import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
  min-height: 85vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.homeBg};
`;

const WelcomeMessage = styled.h1`
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.welcomeText};
`;

const Tagline = styled.p`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.headerText};
  margin-bottom: 40px;
  text-align: center;
  max-width: 600px;
`;


// const PopupOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100vw;
//   height: 100vh;
//   background-color: rgba(0,0,0,0.5);
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

// const Popup = styled.div`
//   background: ${({ theme }) => theme.popupBg};
//   color: ${({ theme }) => theme.popupText};
//   padding: 30px;
//   border-radius: 10px;
//   max-width: 400px;
//   text-align: center;
// `;

// const CloseBtn = styled.button`
//   margin-top: 20px;
//   padding: 8px 20px;
//   border: none;
//   background-color: #aaa;
//   color: white;
//   border-radius: 5px;
//   cursor: pointer;
// `;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.linkText || "#007bff"};
  font-weight: bold;
  text-decoration: underline;
  &:hover {
    color: ${({ theme }) => theme.linkHover || "#0056b3"};
  }
`;

export default function Home() {

  return (
    <Container>
      <WelcomeMessage>Welcome to epicentral.ca!</WelcomeMessage>
      <Tagline>
        Helping you prepare and upload your data with confidence.
        <br /><br />
        ✅ If you are beginning data upload for a new year, please visit our{" "}
        <StyledLink to="/beef/data-uploads">Data Uploads & Procedures </StyledLink>
        page — it has tons of recommendations to guide you.
        <br /><br />
        🔍 Before requesting changes, please double (or triple!) check your data
        to ensure accuracy.
        <br /><br />
        🌐 This site is constantly evolving — refer back often for updates and
        new resources.
      </Tagline>
    </Container>
  );
}
